import * as API from '@/api';

export const actions = {
  async getArtworkFilter({ commit }) {
    const list = await API.GET('/filterTags?type=artwork')

    commit('setArtworkFilter', list.data);
  },
  async getThemeFilter({ commit }) {
    const list = await API.GET('/filterTags?type=theme')

    commit('setThemeFilter', list.data);
  },
  async getTempleFilter({ commit }) {
    const list = await API.GET('/filterTags?type=temple')

    commit('setTempleFilter', list.data);
  },
};
